var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9856 25.4836L10.8656 21.8424L8.42618 23.0073L7.77214 19.8496L4.10394 20.3477L5.40036 11.5349L8.931 10.939L8.33505 7.40835L16.4113 3.62431L17.0072 7.15495L20.5379 6.55901L20.3085 9.50271L24.9853 12.8287L23.9243 21.6017L15.9856 25.4836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8656 21.8424L15.9856 25.4836L23.9243 21.6017L24.9853 12.8287L20.3085 9.50271L20.5379 6.55901L17.0072 7.15495M17.0072 7.15495L16.4113 3.62431L8.33505 7.40835L8.931 10.939L5.40036 11.5349L4.10394 20.3477L7.77214 19.8496L8.42618 23.0073L16.267 19.263L15.6711 15.7323L17.0072 7.15495Z",
    stroke: "#400C7A",
    strokeWidth: 0.794432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06857 11.0368L7.86998 19.712L15.6711 15.7323L16.9094 7.29246L9.06857 11.0368Z",
    fill: "white",
    stroke: "#400C7A",
    strokeWidth: 0.794432
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7867 21.5038L15.8087 15.8301L19.4769 15.3319L20.6357 6.42138",
    stroke: "#400C7A",
    strokeWidth: 0.794432
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/scan.2f3b79cdf4945169b0e7914ae8f5b4e4.svg";
export { ForwardRef as ReactComponent };